<template>
  <div class="manual-container">
    <h2>Εγχειρίδιο Χρήσης</h2>
    <iframe
      :src="pdfUrl"
      width="100%"
      height="800px"
      style="border: none;"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: 'InstitutionsManual',
  data() {
    return {
      pdfUrl: '/manuals/manual-institutions.pdf'
    };
  }
};
</script>

<style scoped>
.manual-container {
  padding: 20px;
}
</style>
